import React, { lazy, Suspense } from 'react';

const LazyApproveRequests = lazy(() => import('./ApproveRequests'));

const ApproveRequests = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyApproveRequests {...props} />
  </Suspense>
);

export default ApproveRequests;
